<template>
  <div class='h-dialogContainer'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-12'>
          <div class='h-col-inputBox'>
            <div class='row' id='alarmHiddenInfoBox'>
              <div v-for='(alarm, index) in alarmHiddenList' :key='index' class='col-sm-6 nopadding' style="padding-left: 0px;">
                <ejs-checkbox ref='alarmHiddenCheck' name='hiddenInfo' :label='alarm.label' :value='alarm.value' :checked='alarm.checked' :change='changeFunc'></ejs-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='h-clear-rowMg'></div>
  </div>
</template>
<script>
export default {
  name: 'alarmHidden',
  data() {
    return {
      alarmHiddenList: [
        { label: this.$t('Alarm.messageNo'), value: 'messageNo', checked: true },
        { label: this.$t('Alarm.alarmHidden_1'), value: 'alarmID', checked: true },
        { label: this.$t('Alarm.alarmHidden_2'), value: 'alarmName', checked: true },
        { label: this.$t('Alarm.alarmHidden_3'), value: 'levelStr', checked: true },
        { label: this.$t('Alarm.alarmHidden_4'), value: 'alarmTypeStr', checked: true },
        // { label: this.$t('Alarm.alarmHidden_5'), value: 'neTypeStr', checked: true },
        // { label: this.$t('Alarm.alarmHidden_6'), value: 'neName', checked: true },
        // { label: this.$t('Alarm.alarmHidden_7'), value: 'equipmentType', checked: true },
        { label: this.$t('Alarm.alarmHidden_8'), value: 'equipmentName', checked: true },
        { label: this.$t('Alarm.alarmHidden_13'), value: 'neAlarmFDN', checked: true },
        { label: this.$t('Alarm.brdType'), value: 'brdTypeStr', checked: true },
        { label: this.$t('Alarm.extraInfo'), value: 'appendInfo', checked: true },
        { label: this.$t('Alarm.xxdwinfo1'), value: 'xxdwinfo1', checked: true },
        // { label: this.$t('Alarm.alarmHidden_9'), value: 'deployIp_Id', checked: true },
        // { label: this.$t('Alarm.alarmHidden_10'), value: 'deployIp', checked: true },
        // { label: this.$t('Alarm.alarmHidden_11'), value: 'envTypeName', checked: true },
        // { label: this.$t('Alarm.alarmHidden_12'), value: 'envName', checked: true },
        // { label: this.$t('Alarm.alarmHidden_14'), value: 'nodeTypeId', checked: true },
        { label: this.$t('Alarm.alarmHidden_15'), value: 'createTimeFormat', checked: true },
        { label: this.$t('Alarm.alarmHidden_16'), value: 'confirmStateStr', checked: true },
        { label: this.$t('Alarm.alarmHidden_17'), value: 'confirmTimeFormat', checked: true },
        { label: this.$t('Alarm.alarmHidden_18'), value: 'confirmUsrName', checked: true },
        { label: this.$t('Alarm.xxdwinfo2'), value: 'xxdwinfo2', checked: true },
        { label: this.$t('Alarm.xxkzinfo1'), value: 'xxkzinfo1', checked: true },
        { label: this.$t('Alarm.xxkzinfo2'), value: 'xxkzinfo2', checked: true },
        { label: this.$t('Alarm.xxkzinfo3'), value: 'xxkzinfo3', checked: true },
        { label: this.$t('Alarm.xxkzinfo4'), value: 'xxkzinfo4', checked: true },
        { label: this.$t('Alarm.cause'), value: 'cause', checked: true },
        { label: this.$t('Alarm.advise'), value: 'advise', checked: true },
        { label: this.$t('Alarm.remark'), value: 'comment', checked: true },
      ],
      alarmHiddenArray: []
    };
  },
  methods: {
    getArray(id) {
      const checkedDom = document.querySelectorAll(`#${id} [aria-checked=false] input`);
      const array = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
      }
      return array;
    },
    changeFunc() {
      this.alarmHiddenArray = this.getArray('alarmHiddenInfoBox');
    },
    getHiddenInfo() {
      return this.alarmHiddenArray;
    },
    setHiddenInfo(obj) {
      const alarmHiddenList = this.alarmHiddenList;
      for (let i = 0; i < alarmHiddenList.length; i++) {
        for(var key in obj) {
          if(alarmHiddenList[i].value == key) {
            alarmHiddenList[i].checked = false;
            break;
          }
        }
      }
      //this.alarmHiddenList = alarmHiddenList;
    },
  }
};
</script>